declare const jQuery: any;
const $ = jQuery;

export function initGoogleTranslateBtn(): void
{
    const $btns = $(`[data-translate-btn]`);
    if ($btns.length === 0)
    {
        return;
    }
    let $googleTranslateEl: any = undefined; // jquery
    const cls = "showing-google-translate";
    const putCodeWrap = ($btn): void => {
        const $parent = $btn.parent();
        if ($parent.hasClass(cls))
        {
            // abort if already appended
            return;
        }
        if ($googleTranslateEl)
        {
            // put the old btn/parent back into its original state
            const $oldParent = $googleTranslateEl.parent();
            $oldParent.removeClass(cls).find(`[data-translate-btn]`).css({ display: "" });
        }
        else
        {
            // need to create the google translate el for the first time
            const html: string = $btn.attr("data-translate-btn");
            if (!html)
            {
                return;
            }
            $googleTranslateEl = $(html);
        }
        $btn.css({ display: "none" });
        $parent.addClass(cls).append($googleTranslateEl);
    };
    $btns.on("click", function (e) {
        const $btn = $(this);
        putCodeWrap($btn);
    });
}
